import React from "react";
import StaffLogin from "./StaffLogin";

export default function OperationsLogin() {
  return <StaffLogin role="operations" redirectTo="/operations/dashboard"
    title="Operations" subtitle="Review and approve partner profiles." />;
}
